import { render, staticRenderFns } from "./ValidationCheckbox.vue?vue&type=template&id=7748e4e2"
import script from "./ValidationCheckbox.vue?vue&type=script&lang=js"
export * from "./ValidationCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports